module.exports = __webpack_public_path__ + "static/media/LoadingImg.04eb06d6.svg";